export default "https://d1e6s5z4lzmgxx.cloudfront.net/ba82fc54-f5ca-4442-8850-d050cbc89c21/images/dragging-icon.svg?01b80fe8718a374509a39e2116e31e8d";